import { clsx } from 'clsx';
import { TransparentButton, Paragraph } from '@hungryroot/ramen';
import styles from './IngredientsList.module.css';

interface Ingredient {
  id: number;
  name: string;
  subText: string;
  imageUrl: string | null;
  isRemoved?: boolean;
  amount?: number;
}

interface IngredientsListProps {
  ingredients: Ingredient[];
  onClick?: (ingredient: Ingredient) => void;
  className?: string;
}

export function IngredientsList(props: IngredientsListProps) {
  const { ingredients, className, onClick } = props;

  return (
    <>
      <div
        className={`${styles.container} ${styles['ingredients-list']} ${className}`}
      >
        {ingredients.map((ingredient) => {
          const {
            id: ingredientId,
            imageUrl,
            name,
            subText,
            isRemoved,
            amount,
          } = ingredient;
          return (
            <TransparentButton
              className={clsx({
                [styles.ingredients]: true,
                [styles.removed]: isRemoved,
                [styles.arrow]: !onClick,
              })}
              key={ingredientId}
              onClick={() => {
                onClick?.(ingredient);
              }}
            >
              {imageUrl !== null && (
                <img
                  className={`${styles['image']}`}
                  src={imageUrl}
                  alt="food-img"
                />
              )}
              <div className={styles['text-container']}>
                <Paragraph variant="body">{name}</Paragraph>
                <Paragraph className={`${styles['subtext']}`} variant="caption">
                  {subText}
                </Paragraph>
              </div>
              {amount && amount > 1 && <Paragraph>x{amount}</Paragraph>}
              {isRemoved && (
                <Paragraph className={styles['removed-text']}>
                  Removed
                </Paragraph>
              )}
            </TransparentButton>
          );
        })}
      </div>
    </>
  );
}
